import { lazy, Suspense } from 'react';

const LazyLoadingBar = lazy(() => import('./loading-bar'));

export default function LoadingBar(props: { loading?: boolean }) {
    return <Suspense fallback={null}>
        <LazyLoadingBar {...props} />
    </Suspense>;
}
